(function () {
  'use strict';

  var isIndex = document.body.classList.contains('template-index');
  var isPage = document.body.classList.contains('template-page');
  if (!isIndex && !isPage) return;

  document.documentElement.classList.add('js-eride-reveal-enabled');

  if (window.Shopify && Shopify.designMode) {
    document.querySelectorAll('.eride-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    if (link.dataset.toggle === 'tab' || link.closest('.product-tab-list, .tab-content')) {
      return;
    }
    link.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  var header = document.querySelector('.header-area');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 60) {
        header.classList.add('eride-header--scrolled');
      } else {
        header.classList.remove('eride-header--scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if ('IntersectionObserver' in window) {
    var globalObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          globalObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 80px 0px' });

    document.querySelectorAll('.eride-reveal:not(.is-visible)').forEach(function (el) {
      globalObs.observe(el);
    });
  }

  if (!isIndex) return;

  var hero = document.querySelector('[data-eride-hero]');
  if (hero && window.matchMedia('(min-width: 768px)').matches) {
    var heroMedia = hero.querySelector('.eride-hero__media');
    if (heroMedia) {
      window.addEventListener('scroll', function () {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom > 0) {
          var offset = window.scrollY * 0.25;
          heroMedia.style.transform = 'translateY(' + offset + 'px)';
        }
      }, { passive: true });
    }
  }

  var immersive = document.querySelector('[data-eride-immersive]');
  if (immersive && 'IntersectionObserver' in window) {
    var immObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          immObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    immObs.observe(immersive);
  }
})();
